const { REACT_APP_API_URL,REACT_APP_CLIENT_TOKEN } = process.env;


export const generateVC = async (schema, schemaProps) => {
    let schemaId;
    let identifier;

    try {
        const schemaidData = await postSchema(schema);
        if (schemaidData.schemaId) {
            schemaId = schemaidData.schemaId;
        } else {
            throw new Error('Schema id not created');
        }
    } catch (error) {
        // console.error('Error generating schema id:', error);
        throw error;
    }

    if (schemaId) {
        const data = {
            "schemaId": schemaId,
            "properties":{...schemaProps}
        };

        try {
            const credData = await postCred(data);
            if (credData.identifier) {
                identifier = credData.identifier;
            } else {
                throw new Error('VC not created');
            }
        } catch (error) {
            console.error('Error posting credentials:', error);
            throw error;
        }
    }

    if (identifier) {
        try {
            const vcOutput = await getCred(identifier);
            if (vcOutput) {
                return vcOutput.credential.vc;
            } else {
                throw new Error('VC not retrieved');
            }
        } catch (error) {
            console.error('Error retrieving credentials:', error);
            throw error;
        }
    } else {
        throw new Error('Identifier not found');
    }
};

// posting schema
const postSchema = async (schema) => {
    try {
        const response = await fetch(`${REACT_APP_API_URL}/schema`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization":`Bearer ${REACT_APP_CLIENT_TOKEN}`
            },
            body: JSON.stringify({ schema }),
        });

        if (!response.ok) {
            throw new Error('Network response error');
        }

        return await response.json();
    } catch (error) {
        console.error('Error creating schema:', error);
        throw error;
    }
};

//posting credential
const postCred = async (data) => {
    try {
        const response = await fetch(`${REACT_APP_API_URL}/cred`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization":`Bearer ${REACT_APP_CLIENT_TOKEN}`
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error('Network response error');
        }

        return await response.json();
    } catch (error) {
        console.error('Error creating credentials:', error);
        throw error;
    }
};

//Getting credential with identifier
const getCred = async (identifier) => {
    try {
        const response = await fetch(`${REACT_APP_API_URL}/cred/${identifier}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization":`Bearer ${REACT_APP_CLIENT_TOKEN}`
            },
        });

        if (!response.ok) {
            throw new Error('Network response error');
        }

        return await response.json();
    } catch (error) {
        console.error('Error retrieving credentials:', error);
        throw error;
    }
};
